import { Ref, RefObject, useCallback, useRef, useState } from 'react';

export const useMergedRef = <T>(
  outerRef: Ref<T | null> | undefined,
  saveInState = true
): [RefObject<T | null>, Ref<T | null>] => {
  const [stateRef, setStateRef] = useState<RefObject<T | null>>({
    current: null,
  });
  const internalRef = useRef<T>(null);

  const mergedRef = useCallback(
    (r: T | null) => {
      if (typeof outerRef === 'function') {
        outerRef(r);
      } else if (outerRef) {
        // eslint-disable-next-line react-hooks/immutability
        outerRef.current = r;
      }
      if (saveInState) {
        setStateRef({ current: r });
      } else {
        internalRef.current = r;
      }
    },
    [outerRef, saveInState]
  );

  return [saveInState ? stateRef : internalRef, mergedRef];
};
